import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  AssociateSubClientAtClientModel,
  CreateSubClientModel,
  DeleteSubClientModel,
  SearchSubClientModel,
} from '../../../models/customer.model'

@Injectable({
  providedIn: 'root',
})
export class SubClientService {
  private baseUrl = environment.baseUrl
  private resource: string = 'SubCliente'

  constructor(private httpClient: HttpClient) {}

  public createSubClient(
    model: any,
    // model: CreateSubClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editSubClient(
    model: any,
    // model: EditSubClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteSubClient(
    model: DeleteSubClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedSubClient(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listSubClient(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getSubClientbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedSubClient(
    page: number,
    rows: number = 15,
    model: any,
    // model: SearchSubClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  /* Client  */
  /*
  listPagedClientBySubClientId
  listPagedNotClientBySubClientId
  searchPagedClientSubClient
   */

  public listPagedSubClientByClientId(
    id: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/associado-cliente/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedNotSubClientByClientId(
    id: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/desassociado-cliente/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedSubClientAssociate(
    page: number,
    rows: number = 15,
    // model: SearchSubClientModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/associado-cliente?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
  /*
  {
    "clienteId": 0,
    "nome": "string",
    "razaoSocial": "string",
    "cnpj": "string",
    "associado": "string"
  }
  */

  public searchPagedClientSubClient(
    page: number,
    rows: number = 15,
    model: SearchSubClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/clients/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public addSubClientAtClient(
    model: AssociateSubClientAtClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create/cliente-subcliente`,
      model,
    )
  }

  public removeSubClientAtClient(
    model: AssociateSubClientAtClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remove`,
      model,
    )
  }
}
